import LoadingTablePlaceholder from './LoadingTablePlaceholder'

export default LoadingTablePlaceholder
